import React, { useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  TextField,
  DialogContent,
  Stack,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
} from "@mui/material";
import { Field, Formik } from "formik";
import CustomTextField from "../forms/theme-elements/CustomTextField";
import CustomCheckbox from "../forms/theme-elements/CustomCheckbox";
import { ChackImageIsFile, inputType } from "src/helper/publicFunction";
import FileUploader from "src/components/shared/AccessibleUploader";
import "./DynamicModal.css";
import { IconCloudUpload, IconX } from "@tabler/icons";
import ActionButton, { iconButtonSx } from "../shared/ActionButton";
import { IconButton } from "@mui/material";
import CustomFormLabel from "../forms/theme-elements/CustomFormLabel";
import EditorComponent from "../editor/Editor";
import GoogleMapCoponent from "../googlemap/googlemap";
import { SketchPicker } from "react-color";
import Autocomplete from "@mui/material/Autocomplete";
import countryData from "../forms/form-elements/autoComplete/countrydata";
import Flag from "../shared/Flag";
import FormControl from "@mui/material/FormControl";
import moment from "moment";
import SaveError from "src/components/shared/SaveError";

// A field's error: a plain sentence under the field, announced when it appears.
const FieldError = ({ children }) =>
  children ? (
    <Typography role="alert" variant="body2" sx={{ color: "error.main", mt: 0.75 }}>
      {typeof children === "string" ? children.charAt(0).toUpperCase() + children.slice(1) : children}
    </Typography>
  ) : null;

// The words on the commit button: pages pass "Edit" / "Add"; say what happens.
const commitLabel = (title, editMode) => {
  const text = typeof title === "string" ? title.trim() : title;
  if (!text) return editMode ? "Save changes" : "Add";
  if (/^(edit|update|save|submit)$/i.test(text)) return "Save changes";
  return text;
};

const DynamicModal = ({
  show,
  setShow,
  faileds,
  failedName = "child",
  title,
  description,
  onSubmit,
  Schema,
  values,
  editMode,
  buttonTitle,
  onChange = ({ value, failedName, setFieldValue }) => {},
  checkSchema = true,
  actionButtonTitle = null,
  actionButtonFunction = null,
  onCloseModal,
  saveError,
}) => {
  const toggle = () => {
    if (show === true) {
      if (onCloseModal) {
        onCloseModal();
      }
    }
    setShow(!show);
  };


  let initialValues = {};

  function convertToInitialValues(faileds, values) {
    for (const item of faileds) {
      if (item.failed) {
        const key = item.failed;
        if (values.hasOwnProperty(key) && key != "password") {
          initialValues[key] = values[key];
        }
      }
      if (item?.child) {
        const childValues = convertToInitialValues([item.child], values);
        Object.assign(initialValues, childValues);
      }
    }
    return initialValues;
  }

  useEffect(() => {
    convertToInitialValues(faileds, values);
  }, []);

  const removeFile = (files, index) => {
    let updatedFiles = Array.from(files);
    updatedFiles.splice(index, 1);
    const newFileList = new FileList(updatedFiles);
    return newFileList;
  };

  // Any field can carry `hint`: one line under it saying what to enter.
  const renderItem = (args) => {
    const field = renderField(args);
    if (!args?.res?.hint) return field;
    return (
      <div style={{ flex: 1, minWidth: 0 }}>
        {field}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
          {args.res.hint}
        </Typography>
      </div>
    );
  };

  const renderField = ({
    res,
    handleChange,
    values,
    handleSubmit,
    setFieldValue,
    errors,
  }) => {
    // console.log({ data_____component: values });
    if (
      res?.type == inputType.email ||
      res?.type == inputType.text ||
      res?.type == inputType.number ||
      res?.type == inputType.textarea ||
      res?.type == inputType.password
    ) {
      return (
        <Field
          component={CustomTextField}
          Title={res?.title}
          name={res?.failed}
          multiline={res?.type == inputType.textarea ? true : false}
          numberOfLines={5}
          maxLength={res?.type == inputType.textarea ? 10000 : 99}
          Customestyle={res?.customdesign ?? null}
          customeStyleText={
            res?.type == inputType.textarea
              ? { height: 100, width: "100%" }
              : null
          }
          value={values[res?.failed]}
          onChange={(e) => {
            handleChange(res?.failed)(e);
            if (onChange) {
              onChange({
                value: e.target.value,
                failedName: res?.failed,
                setFieldValue: setFieldValue,
              });
            }
          }}
          placeholder={res?.placeholder}
          inputMode={res?.type}
          fullWidth={res?.fullwidth}
          id={res?.failed}
          variant="outlined"
          errors={errors[res?.failed]}
        />
      );
    } else if (res?.type == inputType.dropdownSearchMultipleSelect) {
      return (
        <div style={res?.customdesign ?? null}>
          <CustomFormLabel id={`${res?.failed}-label`} htmlFor={res?.failed}>{res?.title}</CustomFormLabel>
          <Autocomplete
            id={res?.failed}
            multiple
            options={res?.datadropdown}
            getOptionLabel={(option) => {
              const label = option?.[res?.faileddropdown?.name];
              return typeof label === "string" ? label : String(label || "");
            }}
            value={
              values[res?.failed] == null || values[res?.failed] == undefined
                ? []
                : values[res?.failed]
            }
            getOptionDisabled={(option) =>
              values[res?.failed]?.some(
                (selected) => selected.id === option[res?.faileddropdown.value]
              )
            }
            onChange={(event, newValue) => {
              setFieldValue(
                res?.failed,
                Array.isArray(newValue)
                  ? newValue.map((item) => {
                      return {
                        id: item[res?.faileddropdown.value],
                        [res?.faileddropdown.name]:
                          item[res?.faileddropdown.name],
                      };
                    })
                  : []
              );
            }}
            renderInput={(params) => (
              <Field
                {...params}
                component={CustomTextField}
                multiline={res?.type == inputType.textarea ? true : false}
                numberOfLines={5}
                maxLength={res?.type == inputType.textarea ? 10000 : 99}
                Customestyle={res?.customdesign ?? null}
                customeStyleText={
                  res?.type == inputType.textarea
                    ? { height: 100, width: "100%" }
                    : null
                }
                placeholder={res?.placeholder}
                inputMode={res?.type}
                fullWidth={res?.fullwidth}
                id={res?.failed}
                variant="outlined"
                errors={errors[res?.failed]}
              />
            )}
            renderTags={(value, getTagProps) => {
              return value.map((option, index) => {
                const matched = res?.datadropdown?.find(
                  (item) =>
                    item?.[res?.faileddropdown?.value] ===
                    option?.[res?.faileddropdown?.value]
                );

                return (
                  <Chip
                    label={
                      option?.[res?.faileddropdown?.name]
                        ? option?.[res?.faileddropdown?.name]
                        : matched?.[res?.faileddropdown?.name] ?? "unknown"
                    }
                    {...getTagProps({ index })}
                  />
                );
              });
            }}
          />
          <FieldError>{errors[res?.failed]}</FieldError>
        </div>
      );
    } else if (res?.type == inputType.dropdownSearch) {
      return (
        <div style={res?.customdesign ?? null}>
          <FormControl fullWidth={res?.fullwidth}>
            <CustomFormLabel id={`${res?.failed}-label`} htmlFor={res?.failed}>{res?.title}</CustomFormLabel>
            <Autocomplete
              id={res?.failed}
              options={res?.datadropdown}
              getOptionLabel={(option) => {
                // works
                return option[res?.faileddropdown.name] || "";
              }}
              value={
                res?.datadropdown?.find(
                  (item) =>
                    item[res?.faileddropdown?.value] === values[res?.failed]
                ) || null
              }
              onChange={(event, newValue) => {
                onChange({
                  value: newValue ? newValue[res?.faileddropdown.value] : null,
                  failedName: res?.failed,
                  setFieldValue: setFieldValue,
                });
                setFieldValue(
                  res?.failed,
                  newValue ? newValue[res?.faileddropdown.value] : null
                );
              }}
              renderInput={(params) => {
                let data = params;
                delete data.inputProps.value;
                delete data.inputProps.defaultValue;

                const selectedOption =
                  res?.datadropdown?.find(
                    (item) =>
                      item[res?.faileddropdown?.value] === values[res?.failed]
                  ) || null;

                // console.log("123", res?.datadropdown);
                // console.log("1234", values);
                // console.log("12345", selectedOption);
                // console.log("Selected value from formik:", values[res?.failed]);

                return (
                  <CustomTextField
                    placeholder={"-"}
                    defaultValue={values[res?.failed] || null}
                    value={
                      selectedOption
                        ? selectedOption[res?.faileddropdown?.name]
                        : ""
                    }
                    Customestyle={{ width: "100%" }}
                    onChange={(event, newValue) => {
                      onChange({
                        value: newValue
                          ? newValue[res?.faileddropdown.value]
                          : null,
                        failedName: res?.failed,
                        setFieldValue: setFieldValue,
                      });
                      setFieldValue(
                        res?.failed,
                        newValue ? newValue[res?.faileddropdown.value] : null
                      );
                    }}
                    {...data}
                    variant="outlined"
                    InputProps={{ ...params.InputProps, endAdornment: null }}
                  />
                );
              }}
            />
          </FormControl>
          <FieldError>{errors[res?.failed]}</FieldError>
        </div>
      );
    } else if (res?.type == inputType.date) {
      const dateValue = values[res?.failed] ? moment(values[res?.failed]).format("YYYY-MM-DD") : "";
      return (
        <div style={res?.customdesign ?? { width: "100%" }}>
          <CustomFormLabel htmlFor={res?.failed}>{res?.title}</CustomFormLabel>
          <TextField
            id={res?.failed}
            type="date"
            fullWidth={res?.fullwidth ?? true}
            value={dateValue}
            error={!!errors[res?.failed]}
            onChange={(event) => {
              onChange({
                value: event.target.value,
                failedName: res?.failed,
                setFieldValue: setFieldValue,
              });
              setFieldValue(res?.failed, event.target.value);
            }}
          />
          <FieldError>{errors[res?.failed]}</FieldError>
        </div>
      );
    } else if (res?.type == inputType.dropdown) {
      return (
        <div style={res?.customdesign ?? null}>
          <CustomFormLabel id={`${res?.failed}-label`}>{res?.title}</CustomFormLabel>
          <Select
            SelectDisplayProps={{ "aria-labelledby": `${res?.failed}-label` }}
            error={!!errors[res?.failed]}
            style={{ width: res?.fullwidth ? "100%" : null }} // Set the width to 100% for full width
            value={values[res?.failed]}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200, // Set the desired height here
                },
              },
            }}
            onChange={(event) => {
              onChange({
                value: event.target.value,
                failedName: res?.failed,
                setFieldValue: setFieldValue,
              });
              setFieldValue(res?.failed, event.target.value);
            }}
          >
            {res?.datadropdown.map((resdropdown) => {
              return (
                <MenuItem value={resdropdown[res?.faileddropdown.value]}>
                  {resdropdown[res?.faileddropdown.name]}
                </MenuItem>
              );
            })}
          </Select>
          <FieldError>{errors[res?.failed]}</FieldError>
        </div>
      );
    } else if (res?.type == inputType.countryPicker) {
      // One searchable field for "which country is this?", filling the name
      // and the flag together. They used to be two separate fields — a free
      // text name and a dropdown of 250 unlabelled flag images with no search
      // — so they could drift apart, and picking the right flag meant
      // recognising it by sight.
      //
      // `res.fills` names the two form fields to write: { name, code }.
      const fillName = res?.fills?.name ?? "name";
      const fillCode = res?.fills?.code ?? "emoji";
      const currentCode = String(values[fillCode] ?? "").toUpperCase();
      const selectedCountry =
        countryData.find((c) => c.code === currentCode) ?? null;

      return (
        <div style={res?.customdesign ?? null}>
          <FormControl fullWidth={res?.fullwidth}>
            <CustomFormLabel id={`${res?.failed}-label`} htmlFor={res?.failed}>{res?.title}</CustomFormLabel>
            <Autocomplete
              id={res?.failed}
              options={countryData}
              autoHighlight
              value={selectedCountry}
              getOptionLabel={(option) => option?.label ?? ""}
              isOptionEqualToValue={(option, value) =>
                option.code === value?.code
              }
              onChange={(event, newValue) => {
                // Only write on an actual selection. Clearing the picker must
                // not wipe the name and flag of a country being edited.
                if (!newValue) return;
                setFieldValue(fillName, newValue.label);
                setFieldValue(fillCode, newValue.code.toLowerCase());
                onChange({
                  value: newValue.code.toLowerCase(),
                  failedName: fillCode,
                  setFieldValue: setFieldValue,
                });
              }}
              renderOption={(props, option) => (
                <Box
                  component="li"
                  sx={{ display: "flex", gap: 1, alignItems: "center" }}
                  {...props}
                  key={option.code}
                >
                  <Flag code={option.code} title={option.label} />
                  <span>{option.label}</span>
                </Box>
              )}
              renderInput={(params) => (
                <CustomTextField
                  {...params}
                  placeholder={res?.placeholder || "Search for a country"}
                  helperText={
                    selectedCountry
                      ? null
                      : "Start typing a country name — this fills the name and flag below."
                  }
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "off",
                  }}
                />
              )}
            />
          </FormControl>
        </div>
      );
    } else if (res?.type == inputType.dropdownemoji) {
      return (
        <div style={res?.customdesign ?? null}>
          <CustomFormLabel id={`${res?.failed}-label`}>{res?.title}</CustomFormLabel>
          <Select
            SelectDisplayProps={{ "aria-labelledby": `${res?.failed}-label` }}
            error={!!errors[res?.failed]}
            style={{ width: res?.fullwidth ? "100%" : null }} // Set the width to 100% for full width
            value={values[res?.failed]}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200, // Set the desired height here
                },
              },
            }}
            onChange={(event) => {
              onChange({
                value: event.target.value,
                failedName: res?.failed,
                setFieldValue: setFieldValue,
              });
              setFieldValue(res?.failed, event.target.value);
            }}
          >
            {res?.datadropdown.map((resdropdown) => {
              let link =
                "https://flagcdn.com/16x12/" +
                resdropdown[res?.faileddropdown.name] +
                ".png";
              return (
                <MenuItem
                  key={resdropdown.id}
                  value={resdropdown[res?.faileddropdown.value]}
                >
                  <img src={link} />
                </MenuItem>
              );
            })}
          </Select>
          <FieldError>{errors[res?.failed]}</FieldError>
        </div>
      );
    } else if (res?.type == inputType.image) {
      return (
        <div style={{ marginTop: 10, marginBottom: 10, width: "100%" }}>
          <CustomFormLabel>{res?.title}</CustomFormLabel>
          <FileUploader
            multiple={res?.multiple}
            label={res?.label}
            name={res?.failed}
            types={res?.fileTypes}
            fileOrFiles={res?.fileOrFiles}
            handleChange={(file) => {
              setFieldValue(res?.failed, file);
            }}
          >
            <div className="custom-dropzone" style={{ width: "100%" }}>
              {values[res?.failed] ? (
                <>
                  {Array.isArray(values[res?.failed]) ||
                  values[res?.failed] instanceof FileList ? (
                    <div className="contanerModal">
                      {Array.from(values[res?.failed]).map(
                        (resarray, index) => {
                          return (
                            <div>
                              <img
                                alt={resarray}
                                src={ChackImageIsFile({
                                  data: resarray,
                                  IsBoolean: false,
                                })}
                                style={{ width: 100, height: 100 }}
                              />
                              {ChackImageIsFile({
                                data: resarray,
                                IsBoolean: true,
                              }) == false ? null : (
                                <p style={{ width: "100%" }}>
                                  {`File name: ${resarray.name}`}
                                </p>
                              )}
                            </div>
                          );
                        }
                      )}
                    </div>
                  ) : (
                    <div style={{ width: "100%" }}>
                      <img
                        src={ChackImageIsFile({
                          data: values[res?.failed],
                          IsBoolean: false,
                        })}
                        alt={values[res?.failed]}
                        style={{ width: 100, height: 100 }}
                      />
                      {ChackImageIsFile({
                        data: values[res?.failed],
                        IsBoolean: true,
                      }) == false ? null : (
                        <p style={{ width: "100%" }}>
                          {`File name: ${values[res?.failed].name}`}
                        </p>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <div>
                  <IconCloudUpload size={36} stroke={1.5} aria-hidden />
                  <p style={{ width: "100%", textAlign: "center" }}>
                    {res.label}
                  </p>
                </div>
              )}
            </div>
          </FileUploader>
          {/* Outside the drop zone: a button inside its label is a control
              inside a control. */}
          {values[res?.failed] ? (
            <ActionButton variant="outlined" tone="destructive" sx={{ mt: 1 }} onClick={() => setFieldValue(res?.failed, "")}>
              Remove {Array.isArray(values[res?.failed]) || values[res?.failed] instanceof FileList ? "these files" : "this file"}
            </ActionButton>
          ) : null}
          <FieldError>{errors[res?.failed]}</FieldError>
        </div>
      );
    } else if (res?.type == inputType.checkbox) {
      const valueToCheckOn = values[res?.failed];
      const checked = valueToCheckOn === 1 || valueToCheckOn === true;
      return (
        <div style={res.customdesign ?? null}>
          {res?.title && <CustomFormLabel>{res?.title}</CustomFormLabel>}
          <CustomCheckbox
            checked={checked}
            color="primary"
            defaultValue={
              values[res?.failed] == 1 || values[res?.failed] == true
                ? true
                : false
            }
            onChange={(value) => {
              setFieldValue(res?.failed, value.target.checked);
              onChange({
                value: value.target.checked,
                failedName: res?.failed,
                setFieldValue: setFieldValue,
              });
            }}
            inputProps={{ "aria-label": res?.title || res?.failed }}
          />
          <FieldError>{errors[res?.failed]}</FieldError>
        </div>
      );
    } else if (res?.type == inputType.action) {
      return (
        <div style={res.customdesign ?? null}>
          <Button
            onClick={() => res.onClick()}
            style={{ width: res?.fullwidth ? "100%" : null }}
          >
            {res?.title}
          </Button>
        </div>
      );
    } else if (res?.type == inputType.title) {
      return (
        <div style={res.customdesign ?? null}>
          {values[res?.failed] ?? res.title}
        </div>
      );
    } else if (res?.type == inputType.editor) {
      return (
        <>
          {res?.title && <CustomFormLabel>{res?.title}</CustomFormLabel>}
          <EditorComponent
            key={res?.failed}
            onChange={(value) => {
              setFieldValue(res?.failed, value);
            }}
            data={values[res?.failed]}
          />
          <FieldError>{errors[res?.failed]}</FieldError>
        </>
      );
    } else if (res?.type == inputType.map) {
      return (
        <>
          {res?.title && <CustomFormLabel>{res?.title}</CustomFormLabel>}
          <GoogleMapCoponent values={values} />
          <FieldError>{errors[res?.failed]}</FieldError>
        </>
      );
    } else if (res?.type == inputType.color) {
      return (
        <>
          {res?.title && <CustomFormLabel>{res?.title}</CustomFormLabel>}
          <div style={res?.customdesign ?? null}>
            <SketchPicker
              width="20%"
              onChange={(value) => {
                setFieldValue(res?.failed, value.hex);
              }}
              color={
                values[res?.failed] == null || !values[res?.failed]
                  ? "#000000"
                  : values[res?.failed]
              }
            />
            <FieldError>{errors[res?.failed]}</FieldError>
          </div>
        </>
      );
    } else if (res?.type == inputType.multipleSelect) {
      return (
        <div>
          <CustomFormLabel id={`${res?.failed}-label`}>{res?.title}</CustomFormLabel>
          <Select
            SelectDisplayProps={{ "aria-labelledby": `${res?.failed}-label` }}
            error={!!errors[res?.failed]}
            style={{ width: res?.fullwidth ? "100%" : null }} // Set the width to 100% for full width
            value={values[res?.failed] ?? []}
            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200, // Set the desired height here
                },
              },
            }}
            multiple
            onChange={(event) => {
              setFieldValue(res?.failed, event.target.value);
              onChange({
                value: event.target.value,
                failedName: res?.failed,
                setFieldValue: setFieldValue,
              });
            }}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value) => {
                  let title = res?.datadropdown?.filter(
                    (responses) =>
                      responses.id === value[res?.faileddropdown.value] ||
                      responses.id === value
                  )[0];
                  return (
                    <Chip
                      key={value[res?.faileddropdown.value]}
                      label={title ? title[res?.faileddropdown.name] : ""}
                    />
                  );
                })}
              </Box>
            )}
          >
            {res?.datadropdown.map((resdropdown) => {
              return (
                <MenuItem value={resdropdown[res?.faileddropdown.value]}>
                  {resdropdown[res?.faileddropdown.name]}
                </MenuItem>
              );
            })}
          </Select>
          <FieldError>{errors[res?.failed]}</FieldError>
        </div>
      );
    }
  };

  // After a submit that fails validation, take the person to the first
  // field that needs them.
  const focusFirstError = () => {
    window.setTimeout(() => {
      const target = document.querySelector('[data-dynamic-modal] [aria-invalid="true"]');
      if (target) {
        target.focus();
        target.scrollIntoView?.({ block: "center" });
      }
    }, 60);
  };

  return (
    <>
      <Dialog
        open={show}
        onClose={toggle}
        aria-labelledby="dynamic-modal-title"
        aria-describedby={description ? "dynamic-modal-description" : undefined}
        fullWidth={true}
        maxWidth="md"
        scroll="paper"
        // Forms read best narrow: 640 at most, full width on a phone.
        PaperProps={{ sx: { maxWidth: { sm: 640 } } }}
        data-dynamic-modal
        // Keyboard users start in the first field they can fill in (hidden
        // fields such as the id are skipped). On close MUI returns focus to
        // the control that opened the dialog.
        TransitionProps={{
          onEntered: (node) => {
            const first = [...node.querySelectorAll("input, textarea, select, [contenteditable='true'], [role='combobox']")].find(
              (el) => !el.disabled && el.type !== "hidden" && el.type !== "file" && el.getAttribute("aria-hidden") !== "true" && el.offsetParent !== null,
            );
            first?.focus();
          },
        }}
      >
        <DialogTitle id="dynamic-modal-title" sx={{ pr: 8 }}>
          {title || description || "Details"}
          {title && description ? (
            <Typography id="dynamic-modal-description" color="text.secondary" sx={{ fontWeight: 400, mt: 0.25 }}>
              {description}
            </Typography>
          ) : null}
          <IconButton aria-label="Close" onClick={toggle} sx={[iconButtonSx, { position: "absolute", right: 12, top: 14 }]}>
            <IconX size={20} />
          </IconButton>
        </DialogTitle>
        <Formik
          validationSchema={Schema ?? null}
          initialValues={initialValues}
          onSubmit={(values) => {
            onSubmit(values);
          }}
        >
          {({ handleChange, handleSubmit, setFieldValue, values, errors }) => (
            <>
              <DialogContent dividers sx={{ pt: 0.5, borderBottom: 0 }}>
                {actionButtonTitle ? (
                  <ActionButton variant="text" sx={{ mt: 1, ml: -1.5 }} onClick={() => actionButtonFunction?.()}>
                    {actionButtonTitle}
                  </ActionButton>
                ) : null}
                <Box
                  component="form"
                  noValidate
                  onSubmit={(event) => {
                    event.preventDefault();
                    handleSubmit();
                    focusFirstError();
                  }}
                >
                  <Stack sx={{ pb: 1 }}>
                  {faileds?.map((res) => {
                    if (res.child) {
                      return (
                        <div className="contanerModal">
                          {renderItem({
                            res: res,
                            handleChange,
                            values,
                            handleSubmit,
                            setFieldValue,
                            errors,
                          })}
                          <div style={{ width: 10 }} />
                          {renderItem({
                            res: res?.child,
                            handleChange,
                            values,
                            handleSubmit,
                            setFieldValue,
                            errors,
                          })}

                          {res?.child?.child ? (
                            <>
                              <div style={{ width: 10 }} />
                              {renderItem({
                                res: res?.child?.child,
                                handleChange,
                                values,
                                handleSubmit,
                                setFieldValue,
                                errors,
                              })}

                              {res?.child?.child?.child ? (
                                <>
                                  <div style={{ width: 10 }} />
                                  {renderItem({
                                    res: res?.child?.child?.child,
                                    handleChange,
                                    values,
                                    handleSubmit,
                                    setFieldValue,
                                    errors,
                                  })}

                                  {res?.child?.child?.child.child ? (
                                    <>
                                      <div style={{ width: 10 }} />
                                      {renderItem({
                                        res: res?.child?.child?.child.child,
                                        handleChange,
                                        values,
                                        handleSubmit,
                                        setFieldValue,
                                        errors,
                                      })}

                                      {res?.child?.child?.child?.child
                                        ?.child ? (
                                        <>
                                          <div style={{ width: 10 }} />
                                          {renderItem({
                                            res: res?.child?.child?.child.child
                                              ?.child,
                                            handleChange,
                                            values,
                                            handleSubmit,
                                            setFieldValue,
                                            errors,
                                          })}
                                        </>
                                      ) : null}
                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </>
                          ) : null}
                        </div>
                      );
                    } else {
                      return (
                        <Box>
                          {renderItem({
                            res,
                            handleChange,
                            values,
                            handleSubmit,
                            setFieldValue,
                            errors,
                          })}
                        </Box>
                      );
                    }
                  })}
                  </Stack>
                  {/* Enter in a field submits, as people expect. */}
                  <button type="submit" hidden aria-hidden tabIndex={-1} />
                </Box>
              </DialogContent>
              {/* A failed save, beside the button that failed (georges-02). */}
              <SaveError message={saveError} sx={{ mx: 3, mb: 1.5 }} />
              <DialogActions sx={{ borderTop: 1, borderColor: "divider", pt: 2 }}>
                <ActionButton variant="text" size="medium" onClick={toggle}>
                  Cancel
                </ActionButton>
                <ActionButton
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    handleSubmit();
                    focusFirstError();
                  }}
                >
                  {commitLabel(buttonTitle, editMode)}
                </ActionButton>
              </DialogActions>
            </>
          )}
        </Formik>
      </Dialog>
    </>
  );
};

export default DynamicModal;
